import type { GridApi } from "ag-grid-community";
import { atom } from "jotai";
import { useEffect, useRef, useState } from "react";
import { useCurrentUser } from "../data/user";

export const apiAtom = atom<GridApi | null>(null);

const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
const isAndroid = /android/i.test(navigator.userAgent);

export const isMobile = isIOS || isAndroid;

// Refresh the page when a given role is removed from the current user's roles
export function useRefreshOnRoleRemoved(role = "refresh") {
  const { roles } = useCurrentUser();
  const prevHadRoleRef = useRef<boolean | undefined>(undefined);

  useEffect(() => {
    const hasRole = roles?.has(role);
    if (hasRole === undefined) return;

    const prevHadRole = prevHadRoleRef.current;
    prevHadRoleRef.current = hasRole;

    if (prevHadRole === true && hasRole === false) {
      try {
        localStorage.setItem("previousRefresh", Date.now().toString());
      } catch (_error) {}
      window.location.reload();
    }
  }, [roles, role]);
}

export function useShiftHeld() {
  const [shiftHeld, setShiftHeld] = useState(false);

  useEffect(() => {
    const keydown = (e: KeyboardEvent) => {
      if (e.key === "Shift") {
        setShiftHeld(true);
      }
    };

    const keyup = (e: KeyboardEvent) => {
      if (e.key === "Shift") {
        setShiftHeld(false);
      }
    };

    window.addEventListener("keydown", keydown);
    window.addEventListener("keyup", keyup);

    return () => {
      window.removeEventListener("keydown", keydown);
      window.removeEventListener("keyup", keyup);
    };
  });

  return shiftHeld;
}
